var productName = 'grid';// Export library
export * from './webpack.entry.js';
// File is symlinked with "grunt symlink" task
export * from './webpack.core.entry.wc.js';
//region WebComponents
export { default as GridTag } from '../lib/Grid/customElements/GridTag.js';
//endregion
